import React from 'react'
import styled, { keyframes, css } from 'styled-components'

const pulse = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(107, 144, 128, 0.45); }
  70%  { box-shadow: 0 0 0 18px rgba(107, 144, 128, 0); }
  100% { box-shadow: 0 0 0 0 rgba(107, 144, 128, 0); }
`

const Card = styled.section`
  background: ${(p) => p.theme?.color?.bgRaised || '#fff'};
  border: 1px solid
    ${(p) =>
      p.$tone === 'urgent'
        ? p.theme?.color?.urgent || '#C24D49'
        : p.$tone === 'success'
        ? p.theme?.color?.accent || '#6B9080'
        : p.theme?.color?.border || '#E6E0D6'};
  border-radius: ${(p) => p.theme?.radius?.lg || '20px'};
  padding: 24px;
  box-shadow: ${(p) => p.theme?.shadow?.card || '0 1px 2px rgba(31,41,55,0.04)'};
  ${(p) =>
    p.$pulse &&
    css`
      animation: ${pulse} 2.4s ease-out infinite;
    `}
  ${(p) =>
    p.$tone === 'urgent' &&
    css`
      background: ${p.theme?.color?.urgentSoft || '#FBEAE9'};
    `}
`

const HeaderRow = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
`

const Title = styled.h3`
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${(p) =>
    p.$tone === 'urgent'
      ? p.theme?.color?.urgent || '#C24D49'
      : p.$tone === 'success'
      ? p.theme?.color?.accent || '#6B9080'
      : p.theme?.color?.inkMuted || '#6B7280'};
`

const Badge = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
`

/**
 * Shared card shell for Today widgets. Renders nothing if `hidden` is true —
 * lets each widget early-return when its data slice is null/empty so the page
 * collapses naturally per PLAN §7.1.
 */
export default function WidgetCard({ title, badge, tone = 'default', pulse = false, hidden = false, children }) {
  if (hidden) return null
  return (
    <Card $tone={tone} $pulse={pulse}>
      {(title || badge) && (
        <HeaderRow>
          {title && <Title $tone={tone}>{title}</Title>}
          {badge && <Badge>{badge}</Badge>}
        </HeaderRow>
      )}
      {children}
    </Card>
  )
}
